import { action, makeObservable, observable } from "mobx";
import { PayAtPaymentLink, ErrorResponse } from "core/types/payat";
import PaymentStore from "./payment.store";

class PayAtStore extends PaymentStore {
    paymentLinks: Array<PayAtPaymentLink> | null | undefined;
    error: ErrorResponse | null | undefined;
    method = "";

    constructor() {
        super();

        makeObservable(this, {
            paymentLinks: observable,
            error: observable,
            method: observable,
            updateMethod: action
        });
    }

    updateError(value: ErrorResponse | null | undefined) {
        this.error = value;
    }

    updatePaymentLinks(value: Array<PayAtPaymentLink>) {
        this.paymentLinks = value;
    }

    updateMethod(value: string) {
        this.method = value;
        this.validate();
    }

    validate() {
        super.validate();
        this.isValid = this.isValid && !!this.method;
    }

    reset() {
        super.reset();

        this.paymentLinks = null;
        this.error = null;
        this.method = "";
    }
}

export default PayAtStore;
